import React, { useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';
import { useAuth } from '../context/AuthContext';
import useCollection from './useCollection';
import { FaFilePdf, FaCommentDots, FaSave, FaTrashAlt } from 'react-icons/fa';

const Script = () => {
  const { profile } = useAuth();
  const { items: comments, loading } = useCollection('script_comments', 'page', true);
  const [scriptUrl, setScriptUrl] = useState('');
  const [form, setForm] = useState({ page: '', text: '' });
  const [msg, setMsg] = useState('');

  const isDirectorOrAdmin = profile?.is_admin || profile?.role === 'director';

  useEffect(() => {
    supabase
      .from('script_config')
      .select('url')
      .eq('id', 1)
      .single()
      .then(({ data }) => {
        if (data) setScriptUrl(data.url || '');
      });
  }, []);

  const handleUrlSave = async (e) => {
    e.preventDefault();
    setMsg('');
    const { error } = await supabase.from('script_config').upsert({ id: 1, url: scriptUrl });
    if (error) {
      setMsg("Erreur lors de la mise à jour du lien.");
    } else {
      setMsg("Lien du script mis à jour avec succès !");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.page || !form.text.trim()) return;
    await supabase.from('script_comments').insert({
      page: Number(form.page),
      text: form.text.trim(),
      author: profile?.name || 'Metteuse en scène',
    });
    setForm({ page: '', text: '' });
  };

  const handleDelete = async (id) => {
    if (window.confirm("Voulez-vous supprimer cette remarque ?")) {
      await supabase.from('script_comments').delete().eq('id', id);
    }
  };

  return (
    <div className="membres-section">
      <h3><FaFilePdf style={{ color: '#e74c3c', marginRight: '8px' }} /> Texte de la pièce & Notes de mise en scène</h3>

      {/* Seuls la metteuse en scène ou l'admin peuvent modifier le lien du script */}
      {isDirectorOrAdmin && (
        <form onSubmit={handleUrlSave} className="membres-inline-form" style={{ marginBottom: '15px' }}>
          <input
            type="url"
            placeholder="Lien vers le scan du texte (Google Drive, PDF...)"
            value={scriptUrl}
            onChange={(e) => setScriptUrl(e.target.value)}
          />
          <button type="submit" className="membres-btn">
            <FaSave /> Enregistrer le lien
          </button>
        </form>
      )}

      {msg && <p className="membres-info" style={{ fontSize: '0.85rem', color: '#007bff' }}>{msg}</p>}

      {scriptUrl ? (
        <div className="info-box" style={{ marginBottom: '20px' }}>
          <p>
            📖 <strong>Accès au texte complet : </strong>
            <a href={scriptUrl} target="_blank" rel="noopener noreferrer" style={{ color: '#007bff', fontWeight: 'bold' }}>
              Ouvrir le script PDF
            </a>
          </p>
        </div>
      ) : (
        <p style={{ opacity: 0.7, fontStyle: 'italic' }}>Aucun lien de script n'a encore été renseigné par la mise en scène.</p>
      )}

      <h4><FaCommentDots style={{ marginRight: '6px' }} /> Remarques & Notes par page</h4>

      {loading ? (
        <p>Chargement des notes...</p>
      ) : (
        <ul className="membres-feed" style={{ listStyle: 'none', paddingLeft: 0 }}>
          {comments.map((c) => (
            <li key={c.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 12px', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
              <div>
                <strong>Page {c.page} :</strong> {c.text} <small style={{ opacity: 0.7 }}>({c.author})</small>
              </div>
              {isDirectorOrAdmin && (
                <button
                  type="button"
                  onClick={() => handleDelete(c.id)}
                  style={{ background: 'none', border: 'none', color: '#dc3545', cursor: 'pointer', padding: '4px' }}
                  title="Supprimer la remarque"
                >
                  <FaTrashAlt />
                </button>
              )}
            </li>
          ))}
        </ul>
      )}

      {/* Formulaire d'ajout de remarque : Réservé uniquement aux Metteurs en scène / Admin */}
      {isDirectorOrAdmin ? (
        <form onSubmit={handleSubmit} className="membres-inline-form" style={{ marginTop: '15px' }}>
          <input
            type="number"
            min="1"
            placeholder="N° page"
            value={form.page}
            onChange={(e) => setForm({ ...form, page: e.target.value })}
            style={{ width: '90px' }}
          />
          <input
            type="text"
            placeholder="Ajouter une remarque de mise en scène..."
            value={form.text}
            onChange={(e) => setForm({ ...form, text: e.target.value })}
          />
          <button type="submit" className="membres-btn">Ajouter la note</button>
        </form>
      ) : (
        <p style={{ marginTop: '15px', opacity: 0.7, fontStyle: 'italic', fontSize: '0.9rem' }}>
          💡 Seule la metteuse en scène peut ajouter de nouvelles consignes sur cette page.
        </p>
      )}
    </div>
  );
};

export default Script;